import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FullWidthGrid from './FullWidthGrid';
import ClientProvider from './client';
export default createDemo(import.meta.url, FullWidthGrid, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/grid/demos/full-width/FullWidthGrid.tsx",
    "fileName": "FullWidthGrid.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Paper from '@mui/material/Paper';\nimport Grid from '@mui/material/Grid';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  color: (theme.vars ?? theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function FullWidthGrid() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Grid container spacing={2}>\n        <Grid size={{ xs: 6, md: 8 }}>\n          <Item>xs=6 md=8</Item>\n        </Grid>\n        <Grid size={{ xs: 6, md: 4 }}>\n          <Item>xs=6 md=4</Item>\n        </Grid>\n        <Grid size={{ xs: 6, md: 4 }}>\n          <Item>xs=6 md=4</Item>\n        </Grid>\n        <Grid size={{ xs: 6, md: 8 }}>\n          <Item>xs=6 md=8</Item>\n        </Grid>\n      </Grid>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 36,
        "focusedLines": 14,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Paper from '@mui/material/Paper';\nimport Grid from '@mui/material/Grid';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  color: (theme.vars ?? theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function FullWidthGrid() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Grid container spacing={2}>\n        <Grid size={{ xs: 6, md: 8 }}>\n          <Item>xs=6 md=8</Item>\n        </Grid>\n        <Grid size={{ xs: 6, md: 4 }}>\n          <Item>xs=6 md=4</Item>\n        </Grid>\n        <Grid size={{ xs: 6, md: 4 }}>\n          <Item>xs=6 md=4</Item>\n        </Grid>\n        <Grid size={{ xs: 6, md: 8 }}>\n          <Item>xs=6 md=8</Item>\n        </Grid>\n      </Grid>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "container"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "xs"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "6"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "md"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "8"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">xs",
              [
                "span",
                "di-ae",
                "="
              ],
              "6 md=8</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "xs"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "6"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "md"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "4"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">xs",
              [
                "span",
                "di-ae",
                "="
              ],
              "6 md=4</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "xs"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "6"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "md"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "4"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">xs",
              [
                "span",
                "di-ae",
                "="
              ],
              "6 md=4</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "xs"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "6"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "md"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "8"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">xs",
              [
                "span",
                "di-ae",
                "="
              ],
              "6 md=8</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 32
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 33
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 36,
    "focusedLines": 14,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Box",
      "@mui/material/Paper",
      "@mui/material/Grid"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
